<mat-card class="overview-card">
	<mat-card-content class="no-padding">
		<div class="row">
			<div fxFlex="33.33%" class="text-center">
				<h5 mat-line class="font-weight-bold margin-top-20">{{ payScale.aircraftModel }}</h5>
				<p mat-line class="readonly-label no-margin-tb">Aircraft Model</p>
			</div>

			<div fxFlex="33.33%" class="text-center">
				<h5 mat-line class="font-weight-bold margin-top-20">{{ payScale.jobTitle }}</h5>
				<p mat-line class="readonly-label no-margin-tb">Job Title</p>
			</div>
		</div>

		<div class="row">
			<div fxFlex="33.33%" class="text-center">
				<h5 mat-line class="font-weight-bold margin-top-20">{{ payScale.perTripPay | currency }}</h5>
				<p mat-line class="readonly-label no-margin-tb">Trip Pay</p>
			</div>

			<div fxFlex="33.33%" class="text-center">
				<h5 mat-line class="font-weight-bold margin-top-20">{{ payScale.availabilityPay | currency }}</h5>
				<p mat-line class="readonly-label no-margin-tb">Availability Pay</p>
			</div>
			<div fxFlex="33.33%" class="text-center">
				<h5 mat-line class="font-weight-bold margin-top-20">{{ payScale.constantApBonus }}%</h5>
				<p mat-line class="readonly-label no-margin-tb">Constant A&P Bonus</p>
			</div>
		</div>

		<div class="row margin-top-20 margin-bottom-20">
			<div class="text-center">
				<mat-form-field>
					<input
						matInput
						numberOnly="positiveNumbers"
						type="text"
						placeholder="Estimated Number of Trips"
						[(ngModel)]="numberOfTrips"
					/>
					<button
						mat-raised-button
						color="primary"
						matSuffix
						aria-label="Calculate"
						(click)="calculate()"
						style="margin-bottom: 5px"
					>
						Calculate
					</button>
				</mat-form-field>
			</div>
		</div>
	</mat-card-content>
	<!-- <mat-card-actions class="card-content">
            <div fxFlexAlign="center">&nbsp;</div>
            <span fxFlex></span>
            <div class="pl-1 text-xs-right text-ellipsis">
               <small class="text-xs-muted">last modified {{ payScale.lastModifiedDate | date : 'short' }} effective {{ payScale.effectiveStart |  date : 'short' }}</small>
            </div>
    </mat-card-actions> -->
</mat-card>
